import script from "./RewardList.vue?vue&type=script&setup=true&lang=js"
export * from "./RewardList.vue?vue&type=script&setup=true&lang=js"

import "./RewardList.vue?vue&type=style&index=0&id=52deab60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52deab60"]])

export default __exports__